export const DEVICE_TYPE_OPTIONS = [
  {
    value: 1,
    label: 'KIRA B50',
  },
  {
    value: 2,
    label: 'KIRA B200',
  },
  {
    value: 3,
    label: 'KIRA CV50',
  },
  {
    value: 4,
    label: 'KIRA BD20',
  },
  {
    value: 5,
    label: 'B 110 R',
  },
  {
    value: 6,
    label: 'B 50 W',
  },
];
